var SupportOrdersFilterConditionsModel, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportOrdersFilterConditionsModel = (function() {
  function SupportOrdersFilterConditionsModel() {}

  SupportOrdersFilterConditionsModel.prototype.sortPurchasedDateAscendingFn = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.purchasedAt);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.purchasedAt);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortPurchasedDateDescendingFn = function(a, b) {
    a = getMillisecondsOfUTCDateFromISOStringDate(a.purchasedAt);
    b = getMillisecondsOfUTCDateFromISOStringDate(b.purchasedAt);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortMerchantNameAscendingFn = function(a, b) {
    a = this.getBusinessName(a);
    b = this.getBusinessName(b);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortMerchantNameDescendingFn = function(a, b) {
    a = this.getBusinessName(a);
    b = this.getBusinessName(b);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortExpiredDateAscendingFn = function(a, b) {
    a = this.parseAndAssignMaxValueIfDateIsNull(a);
    b = this.parseAndAssignMaxValueIfDateIsNull(b);
    return this.sortAscendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.sortExpiredDateDescendingFn = function(a, b) {
    a = this.parseAndAssignMaxValueIfDateIsNull(a);
    b = this.parseAndAssignMaxValueIfDateIsNull(b);
    return this.sortDescendingFunction(a, b);
  };

  SupportOrdersFilterConditionsModel.prototype.getBusinessName = function(order) {
    var name, reservationSource;
    name = (function() {
      var ref;
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          reservationSource = SupportUtilsHelper.getReservationSource(order);
          return reservationSource != null ? reservationSource.hotelName : void 0;
        default:
          return (ref = order.merchant) != null ? ref.name : void 0;
      }
    })();
    return name != null ? name.toUpperCase() : void 0;
  };

  SupportOrdersFilterConditionsModel.prototype.parseAndAssignMaxValueIfDateIsNull = function(a) {
    if (a.groupons[0].expiresAt === null) {
      return a = Number.MAX_VALUE;
    } else {
      return a = getMillisecondsOfUTCDateFromISOStringDate(a.groupons[0].expiresAt);
    }
  };

  SupportOrdersFilterConditionsModel.prototype.sortDescendingFunction = function(a, b) {
    if (a < b) {
      return 1;
    }
    if (b < a) {
      return -1;
    }
    return 0;
  };

  SupportOrdersFilterConditionsModel.prototype.sortAscendingFunction = function(a, b) {
    if (a < b) {
      return -1;
    }
    if (b < a) {
      return 1;
    }
    return 0;
  };

  return SupportOrdersFilterConditionsModel;

})();

module.exports = SupportOrdersFilterConditionsModel;

//# sourceMappingURL=data:application/json;base64,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
